export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paliers"])},
        "target_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif"])},
        "target_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectif"])},
        "reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Récompense (€)"])},
        "reward_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Récompense"])},
        "label_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Libellé (facultatif)"])},
        "label_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ex. : 2 billets d'avion pour l'île Maurice"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales targets"])},
        "target_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target"])},
        "target_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target"])},
        "reward_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reward (€)"])},
        "reward_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reward"])},
        "label_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label (optional)"])},
        "label_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E.g. 2 plane tickets to Mauritius"])}
      }
    }
  })
}
